import Cookies from 'js-cookie'

export const STORAGE_KEY_PREFIX = 'acProject_cookie_consent'
export const GUEST_KEY = `${STORAGE_KEY_PREFIX}_guest`
export const CONSENT_VALUE = '1'

const COOKIE_EXPIRES_DAYS = 365
const MIGRATION_SEPARATOR = ':'

export function userKey (userId: number | string): string {
  return `${STORAGE_KEY_PREFIX}_${userId}`
}

// Читаем из обеих точек: cookie мог быть удалён настройками браузера,
// localStorage — очисткой данных сайта.
export function readConsent (key: string): string | undefined {
  return Cookies.get(key) ?? localStorage.getItem(key) ?? undefined
}

export function writeConsent (key: string, value: string): void {
  Cookies.set(key, value, { sameSite: 'Strict', expires: COOKIE_EXPIRES_DAYS })
  localStorage.setItem(key, value)
}

function currentKey (userId?: number | string | null): string {
  return userId ? userKey(userId) : GUEST_KEY
}

export function hasConsent (userId?: number | string | null): boolean {
  // Значение гостевого ключа — `1` или `1:<userId>` — в обоих случаях означает
  // «согласие дано»: метка после `:` только фиксирует получателя миграции,
  // на факт согласия не влияет.
  return Boolean(readConsent(currentKey(userId)))
}

export function acceptConsent (userId?: number | string | null): void {
  writeConsent(currentKey(userId), CONSENT_VALUE)

  // Авторизованный пользователь даёт согласие напрямую — гостевого ответа
  // от него ещё не было. Занимаем гостевой слот от его имени, чтобы после
  // разлогина плашка не показалась снова. Не трогаем гостевую запись, если
  // она уже существует (в том числе уже помеченная другим пользователем).
  if (userId && !readConsent(GUEST_KEY)) {
    writeConsent(GUEST_KEY, `${CONSENT_VALUE}${MIGRATION_SEPARATOR}${userId}`)
  }
}

// Гостевое согласие переносится ровно один раз — на того, кто авторизовался
// первым. Метка `1:<userId>` фиксирует получателя, поэтому другой пользователь
// в том же браузере плашку увидит и даст согласие сам. Гостевую запись не
// удаляем: разлогинившись, первый пользователь плашку снова не увидит.
export function migrateGuestConsent (userId: number | string): void {
  if (readConsent(userKey(userId))) {
    // У пользователя уже есть собственный ответ. Если гостевая запись ещё
    // не помечена — помечаем её этим пользователем, иначе она останется
    // непомеченной и следующий пользователь унаследует чужое согласие.
    const guest = readConsent(GUEST_KEY)
    if (guest && !guest.includes(MIGRATION_SEPARATOR)) {
      writeConsent(GUEST_KEY, `${CONSENT_VALUE}${MIGRATION_SEPARATOR}${userId}`)
    }
    return
  }

  const guestConsent = readConsent(GUEST_KEY)

  if (!guestConsent || guestConsent.includes(MIGRATION_SEPARATOR)) {
    return
  }

  writeConsent(userKey(userId), CONSENT_VALUE)
  writeConsent(GUEST_KEY, `${CONSENT_VALUE}${MIGRATION_SEPARATOR}${userId}`)
}
